import * as React from 'react';
import { memo } from 'react';

import { generateModifierString } from 'helper/css';

export type FlagProps = {
	text: string;
	modifier?: string | string[];
};

export const Flag = ({ text, modifier }: FlagProps) => {
	const modifiers = generateModifierString('a-flag', modifier);

	return (
		<div className={`a-flag ${modifiers}`}>
			<span className="a-flag__text">{text}</span>
		</div>
	);
};

Flag.displayName = 'Flag';

export default memo(Flag, (prevProps, nextProps) => {
	return prevProps.text === nextProps.text;
});
